export enum UserEvent {
  CREATED = 'TL_USER_CREATED',
  REGISTERED = 'TL_USER_REGISTERED',
  UPDATED = 'TL_USER_UPDATED',
  UPDATED_MARKETING = 'TL_USER_UPDATED_MARKETING',
  FLAGGED = 'TL_USER_FLAGGED',
  CREDIT_ADDED = 'TL_USER_CREDIT_ADDED',
  FAVORITE_CREATED = 'TL_USER_FAVORITE_CREATED',
  FAVORITE_DELETED = 'TL_USER_FAVORITE_DELETED',
}

/** User aggregate stats document lifecycle (event bus channel). */
export enum UserStatsEvent {
  GENERATED = 'GENERATED',
}

export enum UserFavoriteType {
  VENUE = 'VENUE',
  EVENT = 'EVENT',
}

export enum UserFlaggedReason {
  MAX_LOGIN_ATTEMPTS_REACHED = 'MAX_LOGIN_ATTEMPTS_REACHED',
  MAX_INVALID_CREDIT_CARD_ATTEMPTS_REACHED = 'MAX_INVALID_CREDIT_CARD_ATTEMPTS_REACHED',
}

export enum UserFlaggedReasonName {
  MAX_LOGIN_ATTEMPTS_REACHED = 'Max login attempts reached',
  MAX_INVALID_CREDIT_CARD_ATTEMPTS_REACHED = 'Max invalid credit card attempts reached',
}

export enum UserCreditType {
  MANUAL = 'manual',
  PROMO = 'promo',
  BOOKING = 'booking',
  BOOKING_VOID = 'bookingvoid',
  REFERRAL = 'referral',
  REFERRAL_BOOKING = 'referralbooking',
  EXPIRE = 'expire',
}
